<template>
  <div class="therefuel">
    <div class="head">
      <span class="left">{{ site_name }} No.{{ site_id }} {{ device_name }}</span>
      <span class="iconfont icon-you"></span>
    </div>
    <div class="content">
      <h3>{{ device_name }}</h3>
      <div class="text">
        <span>{{ state_text }}</span>
      </div>
    </div>
    <div class="bts">
      <span class="selected" @click="launch">{{ comestate }}</span>
    </div>
  </div>
</template>

<script>
import common from "../../common";
import {MessageBox} from 'mint-ui';
import querystring from "querystring";

export default {
  name: "therefuel",
  data() {
    return {
      site_name: "",
      device_name: "1号枪",
      site_id: "",
      comestate: "启动加油",
      devicemac: "",
      remainingnum_: "",
      state_text: "准备就绪，请确保车辆停在加油机旁，以免错加，造成不必要的损失!",//状态描述
      state: "",//加油机的状态
      orderid_: "",
      timer1: "",
      websock: null,
      token: "",
      controls: false,//是否授权
      ping_time: "",
      timer: null
    }
  },
  methods: {
    launch() {
      let data = JSON.stringify({devicemac: this.devicemac, orderid: this.orderid_, num: this.remainingnum_});
      this.$api.post("wx/yunfeng/order",
          querystring.stringify({
            data, token: this.token,
          })
      ).then(data => {
        console.log(data)
        if (data.data.status == 1) {
          console.log(data.data.data);
          if (data.data.data.code == 1000) {
            this.state_text = "加油机已启动，请在60秒内提枪加油";
          } else {
            this.state_text = "加油机启动失败，请返回重新扫码," + data.data.data.msg;
          }
        } else {

        }
      })
    },
    getOrder() {
      this.$api.post("wx/orderDetail",
          querystring.stringify({
            order_id:this.orderid_, token: this.token,
          })
      ).then(data => {
        console.log(data.data)
        if(data.data.status==1 && data.data.data.pay_status==3){
          this.$router.replace({path: '/orderDetail/' + this.orderid_});
        }
      })
    }
  },
  created() {
    //判断cookie中是否存在token
    let ifcookietoken = document.cookie.indexOf("token=") != -1;
    if (!!JSON.parse(common.getlocalStorage("userInfo"))) {
      this.token = JSON.parse(common.getlocalStorage("userInfo")).token;
    } else if (ifcookietoken) {
      this.token = common.getCookie("token");
    } else {
      this.$router.replace({name: 'login'});
    }
  },
  mounted() {
    let facility_data = JSON.parse(this.$router.currentRoute.params.facility);
    this.devicemac = facility_data.device_mac;
    this.site_id = facility_data.site_id;
    this.device_name = facility_data.device_name;
    this.site_name = facility_data.site_name;
    this.remainingnum_ = facility_data.total_number;
    this.orderid_ = facility_data.order_id;
    this.timer = setInterval(() => {
      this.getOrder()
    }, 5000)
  },
  destroyed() {
    clearInterval(this.timer);
  }
}
</script>

<style>
.therefuel {
  width: 100vw;
  height: 100vh;
  background: #f5f5f5;
}

.therefuel > .head {
  height: 10vh;
  background: white;
  display: -webkit-flex;
  align-items: center;
  padding-left: 0.6rem;
  font-size: 0.6rem;
}

.therefuel .icon-you {
  font-size: 0.6rem;
}

.therefuel .content {
  width: 70%;
  height: 40vh;
  border: 2px solid black;
  border-radius: 0.6rem;
  margin: 0.6rem auto;
  padding: 0.6rem;
}

.therefuel .content h3 {
  font-size: 0.6rem;
  margin: 0;
  padding: 0;
  color: red;
}

.therefuel .content .text {
  font-size: 0.6rem;
}

.therefuel .bts {
  margin: 10vw auto;
  width: 70%;
  height: 8vh;
  border: 2px solid #0097fe;
  display: -webkit-flex;
  border-radius: 0.2rem;
}

.therefuel .bts > span {
  flex: 1;
  text-align: center;
  line-height: 8vh;
  font-size: 0.6rem;
  color: white;
}

.therefuel .bts > .selected {
  background: #0097fe;
}

.addClass {
  padding: 20px !important;
}

.addClass > span {
  padding-top: 0 !important;
}
</style>
    


// WEBPACK FOOTER //
// src/components/yunfeng/therefuel.vue